;(function() {
  'use strict'

  glImageViewerDirective.$inject = ["$log", "$animate", "$compile", "$timeout", "imageViewerService"];
  angular
    .module('core.imageViewer')
    .directive('glImageViewer', glImageViewerDirective)

  /* @ngInject */
  function glImageViewerDirective(
    $log,
    $animate,
    $compile,
    $timeout,
    imageViewerService
  ) {
    $log = $log.create('glImageViewDirective')

    return {
      restrict: 'A',
      link: link,
    }

    function link(scope, element, attrs) {
      // check ng-src attribute exists
      if (!angular.isDefined(attrs.ngSrc)) {
        $log.error('ng-src must be defined on image-viewer element')
      }

      // add class to element to attach styling
      element.addClass('gl-img-view-base')

      // event listeners
      element.on('load', onLoad)
      element.on('error', onError)
      // element.on('click', onClick);

      /**
       * on image load
       */
      function onLoad() {
        scope.$evalAsync(function() {
          $animate.addClass(element, 'loaded').then(addHoverElement)
        })
      }

      /**
       * add hover element to the image to show magnifying glass etc
       */
      function addHoverElement() {
        $timeout(function() {
          var rect = element[0].getBoundingClientRect()
          scope.hoverStyles = {
            width: rect.width + 'px',
            height: rect.height + 'px',
            'margin-left': -rect.width / 2 + 'px',
            // 'margin-top': -rect.height / 2 + 'px',
            position: 'absolute',
            left: '50%',
            // top: '50%'
            top: 0,
          }
          var hoverEl = angular.element(
            '<div class="image-hover" ng-style="{{ hoverStyles }}">' +
              '<div class="gi gi-search">Zoom</div>' +
              '</div>'
          )
          hoverEl.on('click', onClick)
          element.parent().append($compile(hoverEl)(scope))
        }, 100)
      }

      /**
       * on image load error
       */
      function onError() {
        $log.error('image could not be loaded')
      }

      /**
       * click event handler - show image viewer modal
       */
      function onClick() {
        scope.$evalAsync(function() {
          imageViewerService.show(attrs.ngSrc, element)
        })
      }
    }
  }
})()
